import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    without: 'Horas por semana planificando desde cero',
    with: '5 minutos. Todo listo.'
  }, {
    without: 'Ejercicios improvisados sin progresión',
    with: '+200 ejercicios graficados por categoría'
  }, {
    without: 'Grupos caóticos sin sistema',
    with: 'Estructura clara para cada nivel'
  }, {
    without: 'Sin materiales = plata de tu bolsillo',
    with: 'Estrategias para conseguir sponsors reales'
  }, {
    without: 'No podés justificar el aumento de cuota',
    with: 'Sistema para cobrar lo que valés'
  }, {
    without: 'Sensación de improvisar siempre',
    with: 'Llegás a la cancha con todo resuelto'
  }];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-37">
          <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-38">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </motion.div>

        <div className="overflow-x-auto" data-id="element-39">
          <table className="w-full border-collapse" data-id="element-40">
            <thead data-id="element-41">
              <tr className="border-b border-border-card" data-id="element-42">
                <th className="text-left p-4 text-xl font-bold text-red-400" data-id="element-43">
                  Sin VOLEY 360
                </th>
                <th className="text-left p-4 text-xl font-bold text-emerald-400" data-id="element-44">
                  Con VOLEY 360
                </th>
              </tr>
            </thead>
            <tbody data-id="element-45">
              {comparisons.map((row, index) => <motion.tr key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="border-b border-border-card hover:bg-bg-card transition-colors" data-id="element-46">
                  <td className="p-4" data-id="element-47">
                    <div className="flex items-start gap-3" data-id="element-48">
                      <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-49" />
                      <span className="text-text-secondary" data-id="element-50">{row.without}</span>
                    </div>
                  </td>
                  <td className="p-4" data-id="element-51">
                    <div className="flex items-start gap-3" data-id="element-52">
                      <Check className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-53" />
                      <span className="text-text-secondary" data-id="element-54">{row.with}</span>
                    </div>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-55">
          <p className="text-2xl md:text-3xl font-bold" data-id="element-56">
            El lunes podés improvisar o entrar con todo resuelto.
            <br data-id="element-57" />
            <span className="text-orange" data-id="element-58">Vos decidís.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}